import { useState, type FormEvent } from "react"
import { ErroDaApi } from "@/api/erros"
import { usarSessao } from "@/sessao/Sessao"
import { travaLigada } from "@/api/cliente"
import { usarTema } from "@/casca/Tema"

export function Login() {
  const { entrar, carregando } = usarSessao()
  const { alternar, escuroAgora } = usarTema()
  
  const [login, setLogin] = useState("")
  const [senha, setSenha] = useState("")
  const [erro, setErro] = useState<string | null>(null)
  const [mostrarSenha, setMostrarSenha] = useState(false)

  async function enviar(e: FormEvent) {
    e.preventDefault()
    setErro(null)
    try {
      await entrar({ login, senha })
    } catch (x) {
      if (x instanceof ErroDaApi && x.ehNaoEncontrado) {
        setErro("O endpoint POST api/login ainda não existe na ApiSistema — é a tarefa da fase 0 da frente C.")
      } else if (x instanceof ErroDaApi) {
        setErro(x.message)
      } else {
        setErro("Não foi possível falar com o servidor.")
      }
    }
  }

  return (
    <div style={{ minHeight: "100%", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "var(--bg)", padding: 24, fontFamily: "var(--ff, sans-serif)", position: "relative" }}>
      
      <button 
        type="button" 
        onClick={alternar} 
        style={{
          position: "absolute", top: 24, right: 24, background: "none", border: "none", cursor: "pointer",
          color: "var(--txt2)", padding: 8, display: "flex", alignItems: "center", justifyContent: "center"
        }}
        title={escuroAgora ? "Mudar para modo claro" : "Mudar para modo escuro"}
      >
        {escuroAgora ? (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="5"/><line x1="12" y1="1" x2="12" y2="3"/><line x1="12" y1="21" x2="12" y2="23"/><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/><line x1="1" y1="12" x2="3" y2="12"/><line x1="21" y1="12" x2="23" y2="12"/><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/></svg>
        ) : (
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/></svg>
        )}
      </button>

      <div
        style={{
          width: "100%", maxWidth: 420, display: "flex", flexDirection: "column",
          padding: "40px 32px", background: "var(--surface)",
          borderRadius: 12, boxShadow: "var(--sombra)",
          textAlign: "center"
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginBottom: 32 }}>
          <span
            style={{
              display: "flex", alignItems: "center", justifyContent: "center",
              padding: "0 20px", marginBottom: 24
            }}
          >
            <img 
              src={escuroAgora ? "/oc-logo.png" : "/oc-logo-claro.png"} 
              alt="Oficina Conectada" 
              style={{ height: 44, width: "auto", display: "block" }} 
            />
          </span>
          <h1 style={{ margin: "0 0 8px 0", fontSize: 22, fontWeight: 700, color: "var(--txt2)", letterSpacing: "-0.02em" }}>Faça login na sua conta</h1>
          <p style={{ margin: 0, fontSize: 14, color: "var(--txt3)" }}>Bem-vindo! Por favor, insira seus dados</p>
        </div>

        <form onSubmit={enviar} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          <Campo 
            placeholder="E-mail" 
            valor={login} 
            aoMudar={setLogin} 
            tipo="email" 
            autoFocus 
            autoComplete="username" 
          />
          
          <div style={{ position: "relative" }}>
            <Campo 
              placeholder="Senha" 
              valor={senha} 
              aoMudar={setSenha} 
              tipo={mostrarSenha ? "text" : "password"} 
              autoComplete="current-password" 
            />
            <button
              type="button"
              onClick={() => setMostrarSenha(!mostrarSenha)}
              style={{
                position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)",
                background: "none", border: "none", cursor: "pointer", color: "var(--txt3)",
                display: "flex", alignItems: "center", justifyContent: "center", padding: 0
              }}
              title={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
            >
              {mostrarSenha ? (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
              ) : (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
              )}
            </button>
          </div>

          {erro && (
            <p
              role="alert"
              style={{
                margin: 0, padding: "10px 12px", borderRadius: 6, fontSize: 13, lineHeight: 1.4,
                background: "var(--erro-soft)", color: "var(--erro-on-soft)", textAlign: "left", border: "1px solid var(--erro)"
              }}
            >
              {erro}
            </p>
          )}

          <button
            type="submit"
            disabled={carregando || login === "" || senha === ""}
            style={{
              height: 44, borderRadius: 8, background: "var(--brand)", color: "#FFFFFF",
              fontSize: 15, fontWeight: 600, border: "none", cursor: "pointer",
              transition: "opacity 0.2s",
              opacity: carregando || login === "" || senha === "" ? 0.6 : 1,
              marginTop: 4
            }}
          >
            {carregando ? "Entrando…" : "Login"}
          </button>
        </form>

        {travaLigada && (
          <p style={{ margin: "24px 0 0 0", fontSize: 11, lineHeight: 1.4, color: "var(--txt3)" }}>
            Trava do canário ligada: nesta máquina o front só escreve no projeto canário.
          </p>
        )}
      </div>
    </div>
  )
}

function Campo({ placeholder, valor, aoMudar, tipo, ...resto }: {
  placeholder: string
  valor: string
  aoMudar: (v: string) => void
  tipo: string
} & React.InputHTMLAttributes<HTMLInputElement>) {
  return (
    <>
      <style>{`
        .input-login:focus {
          outline: none;
          border-color: var(--brand) !important;
        }
      `}</style>
      <input
        {...resto}
        type={tipo}
        value={valor}
        placeholder={placeholder}
        className="input-login"
        onChange={(e) => aoMudar(e.target.value)}
        style={{
          width: "100%", height: 38, padding: "0 14px", borderRadius: 8,
          border: "1px solid var(--line)", background: "var(--surface)", fontSize: 14,
          color: "var(--txt)", boxSizing: "border-box", transition: "border-color 0.2s"
        }}
      />
    </>
  )
}
